import { observable } from "aurelia-binding";
import { GhgVerificationCorrespondenceEmail, type GhgVerificationModel, GhgVerificationRequestModel } from "../../../../../../../models/ghgs/ghg.models";

export class BaseEnvironmentalVerificationTab {

    public vesselName: string;
    public internationalMaritimeOrganizationNumber: string;
    public isShuttleTanker: boolean;
    public isGeneralCargo: boolean;
    public isContainer: boolean;
    public isLngTanker: boolean;
    public isLpgTanker: boolean;
    public isBulker: boolean;
    public isRoRoCargo: boolean;
    public isCrudeProductsTanker: boolean;
    public isChemicalTanker: boolean;
    public isPassengerCruise: boolean;
    public isDieselElectric: boolean;
    public isDirectDiesel: boolean;
    public model: GhgVerificationRequestModel;
    public isSteamTurbine: boolean;
    public today: string = new Date().toJSON();

    @observable()
    public verifyOptions: { id: number, name: string, isSelected: boolean }[] = [];

    @observable()
    public ghgVerification: GhgVerificationModel;

    @observable()
    public vessel: {
        vesselId:number,
        vesselTypeEEDIGroupCode:string,
        name:string,
        isDieselElectric: boolean,
        isSteamTurbine: boolean,
        isDirectDiesel: boolean,
        internationalMaritimeOrganizationNumber: string,
        vesselType: string
    };

    @observable()
    public correspondenceEmails: GhgVerificationCorrespondenceEmail[] = [];

    activate(model: GhgVerificationRequestModel) {
        this.model = model;
        this.vessel = model.vessel;
        this.ghgVerification = model.ghgVerification;
        this.correspondenceEmails = model.correspondenceEmails || [];
        this.verifyOptions = model.verifyOptions;
    }

    vesselChanged() {
        this.vesselName = this.vessel.name;
        this.isShuttleTanker = (this.vessel.vesselType || '').toLowerCase() == "shuttle tanker";
        this.isGeneralCargo = this.vessel.vesselTypeEEDIGroupCode == "GENERAL-CARGO";
        this.isContainer = this.vessel.vesselTypeEEDIGroupCode == "CONTAINER";
        this.isLngTanker = this.vessel.vesselTypeEEDIGroupCode == "LNG-TANKER";
        this.isLpgTanker = this.vessel.vesselTypeEEDIGroupCode == "LPG-TANKER";
        this.isBulker = this.vessel.vesselTypeEEDIGroupCode == "BULKER";
        this.isRoRoCargo = this.vessel.vesselTypeEEDIGroupCode == "RO-RO-CARGO";
        this.isCrudeProductsTanker = this.vessel.vesselTypeEEDIGroupCode == "CRUDE-PRODUCTS-TANKER-INC-OBO";
        this.isChemicalTanker = this.vessel.vesselTypeEEDIGroupCode == "CHEMICAL-TANKER";
        this.isPassengerCruise = this.vessel.vesselTypeEEDIGroupCode == "PASSENGER-CRUISE";
        this.isDieselElectric = this.vessel.isDieselElectric;
        this.isDirectDiesel = this.vessel.isDirectDiesel;
        this.isSteamTurbine = this.vessel.isSteamTurbine;
        this.internationalMaritimeOrganizationNumber =
            this.vessel.internationalMaritimeOrganizationNumber == '0' ? null : this.vessel.internationalMaritimeOrganizationNumber;
    }
}